module.exports = __webpack_public_path__ + "static/shareAir2BG-c997f6240d2f5c229abc3b9e182c6331.png";